/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seasonal_Crystal_TreesInputs */

const en_seasonal_crystal_trees = /** @type {(inputs: Seasonal_Crystal_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited Seasonal Crystal Trees`)
};

const ar_seasonal_crystal_trees = /** @type {(inputs: Seasonal_Crystal_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أشجار بلورات الزمن الموسمية بلا حدود`)
};

const de_seasonal_crystal_trees = /** @type {(inputs: Seasonal_Crystal_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzte saisonale Time Crystal-Bäume`)
};

const es_seasonal_crystal_trees = /** @type {(inputs: Seasonal_Crystal_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árboles estacionales de cristales de tiempo ilimitados`)
};

const fr_seasonal_crystal_trees = /** @type {(inputs: Seasonal_Crystal_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbres de Cristaux du Temps saisonniers illimités`)
};

const it_seasonal_crystal_trees = /** @type {(inputs: Seasonal_Crystal_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alberi con Cristalli del Tempo stagionali illimitati`)
};

const ja_seasonal_crystal_trees = /** @type {(inputs: Seasonal_Crystal_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`季節限定の時の結晶の木が無制限`)
};

const ko_seasonal_crystal_trees = /** @type {(inputs: Seasonal_Crystal_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무제한 시즌별 타임 크리스탈 나무`)
};

const pt_br_seasonal_crystal_trees = /** @type {(inputs: Seasonal_Crystal_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árvores sazonais de Cristais do Tempo ilimitadas`)
};

const ru_seasonal_crystal_trees = /** @type {(inputs: Seasonal_Crystal_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неограниченные сезонные деревья за Кристаллы времени`)
};

const th_seasonal_crystal_trees = /** @type {(inputs: Seasonal_Crystal_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นไม้คริสตัลแห่งกาลเวลาตามฤดูกาลแบบไม่จำกัด`)
};

const tr_seasonal_crystal_trees = /** @type {(inputs: Seasonal_Crystal_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sınırsız Mevsimlik Zaman Kristali Ağaçları`)
};

const zh_cn_seasonal_crystal_trees = /** @type {(inputs: Seasonal_Crystal_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每季宝石树无限种`)
};

const zh_tw_seasonal_crystal_trees = /** @type {(inputs: Seasonal_Crystal_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每季寶石樹無限種`)
};

/**
* | output |
* | --- |
* | "Unlimited Seasonal Crystal Trees" |
*
* @param {Seasonal_Crystal_TreesInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const seasonal_crystal_trees = /** @type {((inputs?: Seasonal_Crystal_TreesInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seasonal_Crystal_TreesInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seasonal_crystal_trees(inputs)
	if (locale === "ar") return ar_seasonal_crystal_trees(inputs)
	if (locale === "de") return de_seasonal_crystal_trees(inputs)
	if (locale === "es") return es_seasonal_crystal_trees(inputs)
	if (locale === "fr") return fr_seasonal_crystal_trees(inputs)
	if (locale === "it") return it_seasonal_crystal_trees(inputs)
	if (locale === "ja") return ja_seasonal_crystal_trees(inputs)
	if (locale === "ko") return ko_seasonal_crystal_trees(inputs)
	if (locale === "pt_br") return pt_br_seasonal_crystal_trees(inputs)
	if (locale === "ru") return ru_seasonal_crystal_trees(inputs)
	if (locale === "th") return th_seasonal_crystal_trees(inputs)
	if (locale === "tr") return tr_seasonal_crystal_trees(inputs)
	if (locale === "zh_cn") return zh_cn_seasonal_crystal_trees(inputs)
	return zh_tw_seasonal_crystal_trees(inputs)
});